import { Component } from '@angular/core';

@Component({
  selector: 'app-solver-info',
  imports: [],
  templateUrl: './solver-info.html',
  styleUrl: './solver-info.scss'
})
export class SolverInfo {

}
